import {API} from 'aws-amplify';

// @ts-ignore
export const read = async () => API.get('robinhoodEngAdminApi', '/moderators', {});
// @ts-ignore
export const create = async (moderator) => API.put('robinhoodEngAdminApi', '/moderators', {body: moderator});
// @ts-ignore
export const del = async (moderator) => API.del('robinhoodEngAdminApi', '/moderators', {body: moderator});
// @ts-ignore
export const forgot = async (moderator) => API.post('robinhoodEngAdminApi', '/moderators', {body: moderator});
